import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IWheelState {
  selectedValues: number[];
}

const initialState: IWheelState = {
  selectedValues: [5, 5, 5, 5, 5, 5, 5, 5],
};

export const wheelStateSlice = createSlice({
  name: 'wheelState',
  initialState,
  reducers: {
    setWheelSelected: (state, action: PayloadAction<number[]>) => {
      state.selectedValues = action.payload;
    },
  },
});

export const { setWheelSelected } = wheelStateSlice.actions;
export default wheelStateSlice.reducer;
